import React, { useState } from 'react'
import { Alert, Box } from '@mui/material'
import { useGetPlatformMessagesQuery } from '@store/api/notificationApi'

const DISMISSED_KEY = 'cigartrack:dismissed-banners'

function loadDismissed(): Set<string> {
  try {
    const raw = localStorage.getItem(DISMISSED_KEY)
    return new Set(raw ? (JSON.parse(raw) as string[]) : [])
  } catch {
    return new Set()
  }
}

function saveDismissed(keys: Set<string>): void {
  try {
    localStorage.setItem(DISMISSED_KEY, JSON.stringify([...keys]))
  } catch {
    // ignore storage errors
  }
}

const SystemAnnouncementBanner: React.FC = () => {
  const { data: messages = [] } = useGetPlatformMessagesQuery()
  const [dismissed, setDismissed] = useState<Set<string>>(loadDismissed)

  const visible = messages.filter((m) => !dismissed.has(m.key))
  if (visible.length === 0) return null

  const dismiss = (key: string) => {
    setDismissed((prev) => {
      const next = new Set(prev)
      next.add(key)
      saveDismissed(next)
      return next
    })
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
      {visible.map((msg) => (
        <Alert key={msg.key} severity={msg.severity} onClose={() => dismiss(msg.key)}>
          <strong>{msg.title}</strong>
          {msg.message ? ` — ${msg.message}` : ''}
        </Alert>
      ))}
    </Box>
  )
}

export default SystemAnnouncementBanner
